var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.8632L20.3792 12.0989L16 1.09766L11.6208 12.099L0 12.8632L8.91613 20.4213L5.991 31.9013L16 25.5753L26.009 31.9013L23.084 20.4218L32 12.8632ZM16 23.3572L8.971 27.7997L11.0227 19.7478L4.73931 14.43L12.925 13.8923L16 6.16741L19.075 13.8923L27.2703 14.43L20.9772 19.7473L23.029 27.7997L16 23.3572Z",
    fill: "url(#paint0_linear_59070_70958)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59070_70958",
    x1: 0.800001,
    y1: 1.7394,
    x2: 29.034,
    y2: 34.2551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A96AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EAEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#C2D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491919,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#D4DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#ABBDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#BCCAD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6e6668a632023346641af1ae8a06e956.svg";
export { ForwardRef as ReactComponent };